import { useState, useEffect, useRef } from 'react'
import { AxiosUserRepository } from '../../infrastructure/AxiosUserRepository'
import { User, UserFilters } from '../../domain/user'

interface UsePaginationState {
    totalItems: number
    page: number
    itemsPerPage: number
}

export default function useUsers(filters?: UserFilters) {
    const [users, setUsers] = useState<User[]>([])
    const [pagination, setPagination] = useState<UsePaginationState>({
        totalItems: 0,
        page: 1,
        itemsPerPage: 10,
    })
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState<string | null>(null)

    const userRepository = useRef(new AxiosUserRepository())
    const prevFiltersRef = useRef<UserFilters | undefined>(undefined)

    const fetchUsers = async (currentFilters?: UserFilters) => {
        try {
            setLoading(true)
            setError(null)

            const filtersToUse = currentFilters || filters || {}
            const response = await userRepository.current.get(filtersToUse)

            setUsers(response.items)
            setPagination({
                totalItems: response.totalItems,
                page: response.page,
                itemsPerPage: response.size,
            })
        } catch (err) {
            setError(
                err instanceof Error ? err.message : 'Error al cargar usuarios'
            )
            console.error('[v0] Error fetching users:', err)
        } finally {
            setLoading(false)
        }
    }

    // Re-fetch cuando los filtros cambien
    useEffect(() => {
        const filtersChanged =
            JSON.stringify(prevFiltersRef.current) !== JSON.stringify(filters)

        if (filtersChanged) {
            prevFiltersRef.current = filters
            fetchUsers(filters)
        }
    }, [JSON.stringify(filters)])

    const refreshUsers = async () => {
        await fetchUsers(filters)
    }

    return {
        users,
        pagination,
        loading,
        error,
        refreshUsers,
    }
}
